import { useVerifyCode } from "../../../helpers/backend_helper";
import { loadingData, verifyCodeError, verifyCodeSuccess } from "./reducer";

export const verifyCode = (values) => async (dispatch) => {
  try {
    dispatch(loadingData(true));
    const response = await useVerifyCode(values);
    const data = response;
    dispatch(verifyCodeSuccess(data));
    return data;
  } catch (error) {
    const errorMessage = error?.response?.data?.errors;
    dispatch(verifyCodeError(errorMessage));
  } finally {
    dispatch(loadingData(false));
  }
};
